/* Holeshot valve visual picker. Native Symmetry variant-picker handles carts and availability. */
if (!customElements.get('holeshot-valve-picker')) {
  class HoleshotValvePicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.picker = this.closest('variant-picker');
      if (!this.picker) return;
      this.sizeOption = this.dataset.sizeOption || 'Size';
      this.colourOption = this.dataset.colourOption || 'Colour';
      this.sizes = Array.from(this.querySelectorAll('[data-hv-size]'));
      this.colours = Array.from(this.querySelectorAll('[data-hv-colour]'));
      this.colourName = this.querySelector('[data-hv-colour-name]');
      this.preview = this.querySelector('[data-hv-preview]');
      this.previewImage = this.querySelector('[data-hv-preview-img]');
      this.previewLabel = this.querySelector('[data-hv-preview-label]');
      const jsonEl = Array.from(this.picker.querySelectorAll('script[type="application/json"]'))
        .find(el => el.textContent.includes('"variants"'));
      try { this.data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [], photos: {} }; }
      catch (e) { this.data = { variants: [], photos: {} }; console.warn('Holeshot picker data unavailable', e); }
      this.onPick = this.handleClick.bind(this);
      this.onChange = this.sync.bind(this);
      this.addEventListener('click', this.onPick);
      this.picker.addEventListener('on:variant:change', this.onChange);
      this.sync();
    }
    disconnectedCallback() {
      if (this.onPick) this.removeEventListener('click', this.onPick);
      if (this.picker && this.onChange) this.picker.removeEventListener('on:variant:change', this.onChange);
      delete this.dataset.initialized;
    }
    optionInput(option, value) {
      const fieldset = Array.from(this.picker.querySelectorAll('.hv-native-options .option-selector'))
        .find(el => el.dataset.option === option);
      return fieldset ? Array.from(fieldset.querySelectorAll('input.js-option'))
        .find(el => el.value === value) : null;
    }
    selected(option) {
      const fieldset = Array.from(this.picker.querySelectorAll('.hv-native-options .option-selector'))
        .find(el => el.dataset.option === option);
      const input = fieldset && fieldset.querySelector('input.js-option:checked');
      return input ? input.value : '';
    }
    handleClick(event) {
      const size = event.target.closest('[data-hv-size]');
      const colour = event.target.closest('[data-hv-colour]');
      if (size && this.contains(size)) this.choose(this.sizeOption, size.dataset.hvSize);
      else if (colour && this.contains(colour)) this.choose(this.colourOption, colour.dataset.hvColour);
    }
    choose(option, value) {
      const input = this.optionInput(option, value);
      if (!input) return;
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.sync();
    }
    availableWith(index, value, otherIndex, otherValue) {
      return (this.data.variants || []).some(v =>
        v.options && v.options[index] === value &&
        (!otherValue || v.options[otherIndex] === otherValue) &&
        v.available
      );
    }
    sync() {
      const size = this.selected(this.sizeOption);
      const colour = this.selected(this.colourOption);
      this.sizes.forEach(button => {
        const value = button.dataset.hvSize;
        const available = this.availableWith(0, value, 1, colour);
        button.setAttribute('aria-pressed', String(size === value));
        button.setAttribute('aria-label', value + (available ? '' : ', sold out'));
        button.dataset.available = String(available);
        const status = button.querySelector('[data-hv-status]');
        if (status) status.textContent = available ? '' : 'Sold out';
        const matching = (this.data.variants || []).find(v =>
          v.options && v.options[0] === value && v.options[1] === colour);
        const photo = matching && this.data.sizePhotos
          ? this.data.sizePhotos[String(matching.id)] : null;
        const image = button.querySelector('[data-hv-size-image]');
        if (photo && image && image.getAttribute('src') !== photo) image.src = photo;
      });
      this.colours.forEach(button => {
        const value = button.dataset.hvColour;
        const available = this.availableWith(1, value, 0, size);
        button.setAttribute('aria-pressed', String(colour === value));
        button.setAttribute('aria-label', value + (available ? '' : ', sold out'));
        button.dataset.available = String(available);
        const status = button.querySelector('[data-hv-status]');
        if (status) status.textContent = available ? '' : 'Sold out';
      });
      if (this.colourName) this.colourName.textContent = colour || 'Choose colour';
      const variant = (this.data.variants || []).find(v => v.options &&
        v.options[0] === size && v.options[1] === colour);
      // 60/80mm media records currently point to 42mm studio shots, so show the
      // genuine size-specific product photograph in the inline preview.
      const variantId = variant ? String(variant.id) : '';
      const correctLengthPhoto = variant && ['60 mm','80 mm'].includes(size)
        ? this.data.sizePhotos && this.data.sizePhotos[variantId] : null;
      const img = correctLengthPhoto || (this.data.photos && this.data.photos[variantId]);
      if (this.preview) this.preview.hidden = !img;
      if (this.previewImage && img && this.previewImage.getAttribute('src') !== img)
        this.previewImage.src = img;
      if (this.previewLabel) this.previewLabel.textContent = [size, colour].filter(Boolean).join(' / ');

      // The native Symmetry gallery should react to on:variant:change. Also sync
      // the exact Liquid featured_media id as a fallback when variant JSON lacks
      // featured_media (or the gallery did not react to the native event).
      if (variant && this.data.mediaIds) {
        const mediaId = this.data.mediaIds[String(variant.id)];
        const section = this.closest('.js-product');
        const gallery = section && section.querySelector('media-gallery');
        if (mediaId && gallery && typeof gallery.setActiveMedia === 'function') {
          const active = gallery.querySelector('.main-image .slider__item.is-active');
          if (!active || active.dataset.mediaId !== String(mediaId)) {
            const target = gallery.querySelector('.main-image .slider__item[data-media-id="' + String(mediaId) + '"]');
            if (target) gallery.setActiveMedia(mediaId, false);
          }
        }
      }
    }
  }
  customElements.define('holeshot-valve-picker', HoleshotValvePicker);
}